"use client";
import { NextFont } from "next/dist/compiled/@next/font";
import { injectStyle } from "react-toastify/dist/inject-style";
import { useDispatch } from "react-redux";
import EmbeddedWalletProvider from "@/components/Common/EmbeddedWalletProvider";
import AddToHomeScreen from "@/components/AddToHomeScreen/AddToHomeScreen";
import React, { useEffect } from "react";
import { useAppSelector } from "@/redux/hooks";
import { setIsDark } from "@/redux/slice/themeSlice";

// CALL IT ONCE IN YOUR APP
if (typeof window !== "undefined") {
  injectStyle();
}

export default function Theme({
  inter,
  child,
}: {
  child: React.ReactNode;
  inter: NextFont;
}) {
  const dispatch = useDispatch();
  const { isDark } = useAppSelector((state) => state.theme);

  useEffect(() => {
    const darkMode: string =
      typeof window !== "undefined" &&
      // @ts-ignore
      JSON.parse(window.localStorage.getItem("isDarkMode"));
    if (!darkMode) {
      dispatch(setIsDark(false));
    }
  }, [isDark]);

  return (
    <html
      lang="en"
      suppressHydrationWarning={true}
      data-mode={isDark ? "dark" : ""}
    >
      <head>
        <link rel="manifest" href="/manifest.json" />
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, interactive-widget=resizes-content"
        />
        <meta charSet="UTF-8" />
        <title>Out</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Titan+One&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Public+Sans:wght@700&display=swap"
          rel="stylesheet"
        />
      </head>
      <body
        className={`${inter.className} h-screen ${
          isDark ? "dark bg-outbackground-main" : ""
        }`}
      >
        <main className={`bg-outbackground-main text-outext-main `}>
          <AddToHomeScreen />
          <EmbeddedWalletProvider>{child}</EmbeddedWalletProvider>
        </main>
      </body>
    </html>
  );
}
